import React from "react";
import PropTypes from "prop-types";

const TabsFilter = React.memo(({ data, activeTab, variant }) => {
  if (variant === "wa") {
    return (
      <div
        className="inline-flex max-w-full flex-wrap items-center gap-1 rounded-xl border border-[#2a3942] bg-[#111b21] p-1"
        role="tablist"
        aria-label="Filter"
      >
        {data.length > 0 &&
          data.map((item, index) => {
            const active = activeTab === item.name;
            return (
              <button
                key={item.id ?? index}
                type="button"
                role="tab"
                aria-selected={active}
                onClick={item.onClick}
                className={`whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                  active
                    ? "bg-[#00a884] text-white shadow-sm"
                    : "text-[#8696a0] hover:bg-[#2a3942] hover:text-[#e9edef]"
                }`}
              >
                {item.name}
              </button>
            );
          })}
      </div>
    );
  }

  return (
    <div className="flex h-12 rounded-md border border-gray-300 sm:flex-none dark:border-gray-600">
      {data.length > 0 &&
        data.map((item, index) => (
          <button
            key={index}
            type="button"
            onClick={item.onClick}
            className={`m-1 rounded px-4 dark:text-white ${
              activeTab === item.name
                ? "bg-gray-500 text-white shadow dark:bg-green-700"
                : "bg-transparent dark:bg-gray-700"
            }`}
          >
            {item.name}
          </button>
        ))}
    </div>
  );
});

TabsFilter.displayName = "TabsFilter";

TabsFilter.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      onClick: PropTypes.func,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ).isRequired,
  activeTab: PropTypes.string,
  variant: PropTypes.oneOf(["wa"]),
};

export default TabsFilter;
